module.exports = __webpack_public_path__ + "media/grit2.b2299b6e.mp3";